module.exports = __webpack_public_path__ + "img/20210116_110139.3e10ac91.jpg";